export { analyticsMixin } from './analytics';
export { articlesMixin } from './articles';
export { categoryMixin } from './category';
export { clickOutMixin } from './clickOut';
export { comparisonMixin } from './comparison';
export { countdownTimerMixin } from './countdownTimer';
export { facebookMixin } from './facebook';
export { faqMixin } from './faq';
export { foodIconsMixin } from './foodIcons';
export { helper } from './helper';
export { navigationMixin } from './navigation';
export { navigationItemsMixin } from './navigationItems';
export { overlayMixin } from './overlay';
export { check24WidgetMixin } from './check24Widget';
export {
    partnerMixin,
    partnerDescriptionTypes,
    partnerDescriptionDetailTypes,
} from './partner';
export { partnersMixin } from './partners';
export { rankingMixin } from './ranking';
export { reviewMixin } from './review';
export { sidebarMixin } from './sidebar';
export { submitQuiz } from './submitQuiz';
export { componentsMixin } from './components';
export { routeMixin } from './route';
export { mediaQueriesMixin } from './mediaQueries';
export { partnerIconMixin } from './partnerIcon';
export { heroBannerMixin } from './heroBanner';
export { flexibleSpaceMixin } from './components/flexible-space';
export { adBannerLogic } from './components/ad-banner';
export { heroBannerLogic } from './components/hero-banner';
export { colorMixin } from './color';
export { scoreMixin } from './partnerScore';
export { quizMixin } from './quiz';
export { contentDirectionMixin } from './contentDirection';

export const DateMixin = {
    methods: {
        fallbackDate() {
            const monthNames = [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December',
            ];

            const date = new Date();

            if (window.__host__['last_updated_month']) {
                return `${this.$t(
                    monthNames[date.getMonth()]
                )}, ${date.getFullYear()}`;
            }

            date.setDate(date.getDate() - 3);
            const month = date.getMonth();

            return `${this.$t(
                monthNames[month]
            )} ${date.getDate()}, ${date.getFullYear()}`;
        },
        getBrowserData() {
            const lang = window.__host__
                ? window['__host__']['language_code']
                : 'en';

            try {
                if (Intl.Collator.supportedLocalesOf(lang).length === 0) {
                    return null;
                }
            } catch (e) {
                return null;
            }

            const date = new Date();

            if (window.__host__['last_updated_month']) {
                return date.toLocaleDateString(lang, {
                    year: 'numeric',
                    month: 'long',
                });
            }

            date.setDate(date.getDate() - 3);
            return date.toLocaleDateString(lang, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            });
        },
    },
};
